"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

var _FixedMenuLayout = require("../../layouts/FixedMenuLayout");

var _FixedMenuLayout2 = _interopRequireDefault(_FixedMenuLayout);

var _Wizard = require("../Wizard/Wizard");

var _Wizard2 = _interopRequireDefault(_Wizard);

var _universalCookie = require("universal-cookie");

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      


var cookies = new _universalCookie2.default();

var Editor = function (_React$Component) {
	_inherits(Editor, _React$Component);

	function Editor(props) {
		_classCallCheck(this, Editor);

		var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));

		_this.state = {
			showModalReset: false,
			header: null,
			organization: null
		};

		_this.childWizard = _react2.default.createRef();

		return _this;
	}

	// eslint-disable-next-line camelcase


	_createClass(Editor, [{
		key: "UNSAFE_componentWillMount",
		value: function UNSAFE_componentWillMount() {

			//this.setState({ header: this.props.header });

			/*
   		if (this.props.location && this.props.location.state) {
   		const {isAuth, header } = this.props.location.state;
   		//console.info("add cookie", this.props.location.header);
   		cookies.set("myToken", this.props.location.header, { path: "/" });
   		this.setState({ isAuth: isAuth, header: header });
   	} else {
   		this.userLogged();
   		}
   */

		}
	}, {
		key: "componentDidMount",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var logged;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return this.userLogged();

							case 2:
								logged = _context.sent;


								this.setState({
									header: logged ? "logged" : "no_logged"
								});

							case 4:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function componentDidMount() {
				return _ref.apply(this, arguments);
			}

			return componentDidMount;
		}()
	}, {
		key: "userLogged",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
				var _organization, _header;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:

								//console.info("cookieOrga", cookies.get("myOrganization"));

								//console.info("props", this.props.header.organization);
								_organization = this.props.header && this.props.header.organization ? this.props.header.organization : cookies.get("myOrganization");
								_context2.next = 3;
								return _share2.default.getUserLogged(cookies.get("myToken"));

							case 3:
								_header = _context2.sent;


								this.setState({
									header: _header,
									organization: _organization
								});

								return _context2.abrupt("return", _header);

							case 6:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function userLogged() {
				return _ref2.apply(this, arguments);
			}

			return userLogged;
		}()
	}, {
		key: "doResetEditor",
		value: function doResetEditor() {

			//console.info("Editor NOU doResetEditor");
			//localStorage.setItem(CURRENT_STEP, PAS0_SELECCIO_BD);
			localStorage.clear();
			this.setState({ showModalReset: false });
			this.childWizard.current.updateCurrentStep(_constants.PAS0_SELECCIO_BD, true);
			window.open(_constants.URL_BASE_EDITOR, "_self");
		}
	}, {
		key: "renderNouVisorButton",
		value: function renderNouVisorButton() {
			var _this2 = this;

			return _react2.default.createElement(
				_semanticUiReact.Menu.Item,
				{ position: "right" },
				_react2.default.createElement(_semanticUiReact.Button, { color: "teal", icon: "map outline", labelPosition: "left", content: "Nou Visor", onClick: function onClick() {
						return _this2.setState({ showModalReset: true });
					} })
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this3 = this;

			if (this.state.header === "logged") {

				return _react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_FixedMenuLayout2.default, { organization: this.state.organization, renderButtons: this.renderNouVisorButton() }),
					_react2.default.createElement(_Wizard2.default, { ref: this.childWizard, organization: this.state.organization, currentId: this.props.match.params.id }),
					_react2.default.createElement(
						_semanticUiReact.Modal,
						{ size: "mini", open: this.state.showModalReset, closeOnEscape: true },
						_react2.default.createElement(
							_semanticUiReact.Modal.Header,
							null,
							"Crear un nou visor"
						),
						_react2.default.createElement(
							_semanticUiReact.Modal.Content,
							null,
							_react2.default.createElement(
								"p",
								null,
								"Vol crear un nou visor? "
							),
							_react2.default.createElement(
								"p",
								null,
								"Perdr\xE0 la configuraci\xF3 actual i tornar\xE0 al PAS 1"
							)
						),
						_react2.default.createElement(
							_semanticUiReact.Modal.Actions,
							null,
							_react2.default.createElement(_semanticUiReact.Button, { color: "red", inverted: true, onClick: function onClick() {
									return _this3.setState({ showModalReset: false });
								}, icon: "close", labelPosition: "right", content: "No" }),
							_react2.default.createElement(_semanticUiReact.Button, { positive: true, onClick: function onClick() {
									return _this3.doResetEditor();
								}, icon: "checkmark", labelPosition: "right", content: "Si" })
						)
					)
				);
			} else if (this.state.header === "no_logged") {

				return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: "/login", origin: "editor" } });
			} else {

				return _react2.default.createElement(
					_semanticUiReact.Dimmer,
					{ active: true, page: true },
					_react2.default.createElement(
						_semanticUiReact.Header,
						{ as: "h2", icon: true, inverted: true },
						_react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: "rain" }),
						"Autenticant...",
						_react2.default.createElement(
							_semanticUiReact.Header.Subheader,
							null,
							"Plou i fa sol ...."
						)
					)
				);
			}
		}
	}]);

	return Editor;
}(_react2.default.Component);

exports.default = Editor;


Editor.propTypes = {
	header: _propTypes2.default.object,
	params: _propTypes2.default.object,
	location: _propTypes2.default.object
};
